import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export const MAIN_NOTICE = 'ALTERNATIVE_NOTICE_2';

const { persistAtom } = recoilPersist();

export const neverSeeAgainState = atom({
  key: 'neverSeeAgain',
  default: {
    notice: '',
    lastestNotice: ''
  },
  effects_UNSTABLE: [persistAtom]
});
